import script from "./SelectLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectLogin.vue?vue&type=script&setup=true&lang=ts"

import "./SelectLogin.vue?vue&type=style&index=0&id=061a5ae7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-061a5ae7"]])

export default __exports__